import React from 'react';
import { Input, OriSelect } from 'src/components/Antd';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import {
  Field,
  FieldFormItem,
  antdErrorDisplayAdaptor,
} from 'src/components/RcForm';
import {
  buttonLink,
  buttonText,
  buttonThemeUuid,
} from 'src/tools/contentModulesFieldName';
//import css from './css.module.less';
// import { EnumModuleType } from 'src/types/common/module';
import LinkLibrary from '@/src/constrains/LinkLibrary';
import { get } from 'lodash';
import { useParams } from 'react-router-dom';
import { useSalesChannelGeneralLinkSet } from 'src/components/LinkModule/hooks';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import { i18nGet } from 'src/tools/tools';
const Option = OriSelect.Option;

const ButtonThemeTextLink = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled, themeOptions, validators, breakpoint } = props;
  const { link: lV, text: teV, theme: thV } = validators || {};
  const _params: any = useParams();
  const { contentUuid } = _params;
  const linkSet = useSalesChannelGeneralLinkSet({ contentUuid });
  return (
    <Section {...sectionProps}>
      <ItemWrapper
        title={`${getI18n('salesChannelContent.index.buttonTheme')}*`}>
        <Field
          name={buttonThemeUuid}
          rules={[
            {
              // validateTrigger: 'onSubmit',
              validator: async (rules: any, value: any) => {
                if (thV) {
                  const res = thV(value, { breakpoint });
                  console.log('res', res);
                  const hasError = get(res, 'hasError');
                  const errors = get(res, 'errors');
                  if (hasError) {
                    return Promise.reject(new Error((errors || []).join(',')));
                    //</ItemWrapper>throw Error((errors || []).join(','));
                  }
                }
              },
            },
          ]}>
          {(props, m) => {
            const eP = antdErrorDisplayAdaptor(m);
            return (
              <FieldFormItem {...eP}>
                <OriSelect
                  disabled={disabled}
                  size='large'
                  {...props}
                  //   value={moduleWidth}
                  //   onChange={handleOnModuleWidthChange}
                >
                  {themeOptions.map((i) => {
                    const { label, value } = i;
                    return (
                      <Option value={value} key={value}>
                        {label}
                      </Option>
                    );
                  })}
                </OriSelect>
              </FieldFormItem>
            );
          }}
        </Field>
      </ItemWrapper>
      <ItemWrapper title={`${getI18n('general.buttonText')}*`}>
        <Field
          name={buttonText}
          rules={[
            {
              // validateTrigger: 'onSubmit',
              validator: async (rules: any, value: any) => {
                if (teV) {
                  const res = teV(value, { breakpoint });

                  const hasError = get(res, 'hasError');
                  const errors = get(res, 'errors');
                  if (hasError) {
                    return Promise.reject(new Error((errors || []).join(',')));
                    //</ItemWrapper>throw Error((errors || []).join(','));
                  }
                }
              },
            },
          ]}>
          {(props, m) => {
            const eP = antdErrorDisplayAdaptor(m);

            return (
              <Input
                maxLength={40}
                size='large'
                placeholder={getI18n(
                  'salesChannelContent.index.pleaseinputbuttontext',
                )}
                {...props}
                {...m}
                {...eP}
              />
            );
          }}
        </Field>
      </ItemWrapper>
      <Field
        name={buttonLink}
        rules={[
          {
            // validateTrigger: 'onSubmit',
            validator: async (rules: any, value: any) => {
              if (lV) {
                const res = lV(value, { breakpoint });

                const hasError = get(res, 'hasError');
                const errors = get(res, 'errors');
                if (hasError) {
                  return Promise.reject(new Error((errors || []).join(',')));
                  //</ItemWrapper>throw Error((errors || []).join(','));
                }
              }
            },
          },
        ]}>
        {(props, meta) => {
          const value = props.value;
          const onChange = props.onChange;
          const errors = get(meta, 'errors');
          return (
            <LinkLibrary
              customTitle={`${getI18n('general.linkModule.Modal.link')}*`}
              error={(errors || []).join(' ')}
              data={value}
              onChange={onChange}
              linkSet={linkSet}
            />
          );
        }}
      </Field>
    </Section>
  );
};
export default ButtonThemeTextLink;
